import {Grid, List, ListItem} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ModificaPianoDialogStyles from "./ChangePlanBySimConfirmationDCStyles";
import PropTypes from "prop-types";

const ChangePlanBySimConfirmationDC = (props) => {
    const classes = ModificaPianoDialogStyles();

    return (
        <Grid container className={classes.list}>

        <Grid item>
                <Typography variant="body1">
                    {props.text}
                </Typography>
            </Grid>

            {props.sims ?
                <List
                    className={classes.content}
                    dense={true}>
                    {props.sims.map((sim, idx) => {
                        return (
                            <ListItem style={{paddingLeft: "0px"}}
                                      key={`change-plan-by-sim-${idx}`}>
                                <Typography variant="subtitle1">
                                    {sim.msisdn}
                                </Typography>
                            </ListItem>
                        )
                    })}
                </List> : null}
        </Grid>
    );
};

ChangePlanBySimConfirmationDC.propTypes = {
    text: PropTypes.string.isRequired,
    sims: PropTypes.arrayOf(
        PropTypes.shape({
            iccId: PropTypes.string.isRequired,
            msisdn: PropTypes.string.isRequired
        }))
}

export default ChangePlanBySimConfirmationDC;
